import initiative from "@/store/adventure/initiative";
import characters from "@/store/adventure/characters";
import nonPlayerCharacters from "@/store/adventure/nonPlayerCharacters";
import monsters from "@/store/adventure/monsters";
import designDetails from "@/store/adventure/designDetails";

export default {
  namespaced: true,
  modules: {
    initiative,
    characters,
    nonPlayerCharacters,
    monsters,
    designDetails,
  },
  state: {},
  getters: {},
  mutations: {},
};
